const usePagination = ({ setCurrentPage, currentPage, maxPage }) => {
  const sanitizedMax = Math.max(1, maxPage || 1);
  const normalizedCurrent = Math.min(Math.max(currentPage || 1, 1), sanitizedMax);

  // Build window of up to three pages centered around current page
  const windowSize = 3;
  const halfWindow = Math.floor(windowSize / 2);
  let start = normalizedCurrent - halfWindow;
  let end = normalizedCurrent + halfWindow;

  if (start < 1) {
    end += 1 - start;
    start = 1;
  }

  if (end > sanitizedMax) {
    const diff = end - sanitizedMax;
    start = Math.max(1, start - diff);
    end = sanitizedMax;
  }

  const currentThree = [];
  for (let page = start; page <= end; page += 1) {
    currentThree.push(page);
  }

  const next = () => {
    setCurrentPage((prev) => {
      const nextPage = Math.min((prev || 1) + 1, sanitizedMax);
      return nextPage;
    });
  };

  const prev = () => {
    setCurrentPage((prev) => {
      const prevPage = Math.max((prev || 1) - 1, 1);
      return prevPage;
    });
  };

  const jump = (page) => {
    if (page < 1 || page > sanitizedMax) return;
    const pageNumber = Math.max(1, Math.min(page, sanitizedMax));
    setCurrentPage(pageNumber);
  };

  return { next, prev, jump, currentThree };
};

export default usePagination;
